module.exports = __webpack_public_path__ + "img/more_btn.9d014781.svg";